import {BasePage} from "./base-page";

export default class PostsPage extends BasePage {

  async onDocumentReady() {
    console.log('PostsPage ready!!')
    super.onDocumentReady()
    await this.asyncGetAccount(false,false);
    this.initMethod()
    this.positionElement()
  }

  positionElement() {
    let positionElement = this.getCategoryByLocation()
    if (positionElement != "") {
      let x = $("." + positionElement).offset().left
      $(".nav-container").scrollLeft(x);
    }
  }

  getCategoryByLocation(): string {
    let pageLocation = location.pathname
    let pageArr = pageLocation.split("/")
    if (pageArr[1] == "article" && pageArr[2] == "category" && pageArr[3] != null) {
      return pageArr[3]
    }
    return ""
  }

  initMethod() {
    if (this.system === 'pc') {
      $('body').find('.carousel-indicators .pc-none').remove();
      $('body').find('.carousel-inner .pc-none').remove();
    }
  }

}
